import { Directive } from "@angular/core";

@Directive({ selector: "[appSinglebasic]" })
export class SinglebasicDirective {}
